
import React, { Component } from 'react'
import { Modal, Button, Row, Col, Form, Input, Select } from 'antd'
import { api } from '../../../../services'

class ModalCreate extends Component {
  state = {
    isSubmiting: false,
    error: null,
  }

  onCancel = () => {
    const { onCancel } = this.props

    if (onCancel) {
      onCancel()

      this.setState({
        error: null
      })
    }
  }

  createDivision = (e) => {
    const { callback } = this.props

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          isSubmiting: true
        })

        api.division.createDivision(values)
          .then(response => {
            if (response.data.result) {
              callback()
              this.onCancel()
            }

            if (response.data.error) {
              this.setState({
                error: response.data.error.message
              })
            }

            this.setState({
              isSubmiting: false
            })
          })
          .catch(error => {
            this.setState({
              error: error.response.data.error.message,
              isSubmiting: false
            })
          })
      } else {
        // console.log('error', values)
      }
    })
  }

  handleName = (rule, value, callback) => {
    if (!value) {
      callback('Please input division name')
    } else if (!value.replace(/\s/g, '').length) {
      callback('String only contains whitespace')
    } else if (value.length > 255) {
      callback('Max 255 symbols')
    } else {
      callback()
    }
  }

  render () {
    const { visible, form: { getFieldDecorator }, organization } = this.props
    const { isSubmiting, error } = this.state

    return (
      <Modal
        visible={visible}
        title='Create a division'
        wrapClassName='vertical-center-modal'
        width={380}
        onCancel={this.onCancel}
        footer={[
          <Button key='submit' type='indigo' loading={isSubmiting} onClick={this.createDivision}>Create</Button>
        ]}
        destroyOnClose
      >
        { error && <div className='form__error'>{ error }</div>}
        <Form onSubmit={this.createDivision}>
          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Organization'>Organization</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('organizationId', {
                })(
                  <Select
                    placeholder='Select organization'
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    { organization.list.map(org => <Select.Option key={org.id.toString()}>{ org.name }</Select.Option>) }
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Name'>Name</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('name', {
                  rules: [{
                    validator: this.handleName
                  }]
                })(
                  <Input name='name' />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Number of licenses'>Licenses</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('licenseNumber', {
                  rules: [{
                    required: true,
                    message: 'Please input number of licenses',
                    max: 7,
                    pattern: /^(0|[1-9][0-9]*)$/
                  }]
                })(
                  <Input name='licenseNumber' maxLength={7} />
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    )
  }
}

export default Form.create()(ModalCreate)



// WEBPACK FOOTER //
// ./src/views/Divisions/components/ModalCreate/ModalCreate.jsx